import React, { useState,useRef,useEffect, useMemo  } from 'react';
import {getGlobalDiscount} from '../../services/cashFlow/cashFlow'
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import {cedimi} from '../../constant/globalConstantsTypeClients';
import moment from 'moment';
import * as XLSX from 'xlsx';
import {getAllBranches } from '../../services/commercialLine/commercialLine'
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useHistory } from 'react-router-dom';
import { validarSesion } from '../tokens/useToken';


export const useReportLogExam = () => {

    // ? REPORT
    const history = useHistory();

    const [createSweet] = useSweetAlert();
    const [loading, setLoading] = useState(false);
    const [reportLogs, setReportLogs] = useState([]);
    const [users, setUsers] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);


    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        mDateRange1: "",
        mDateRange2: "",
        mSelectUser: null,

    });
    

    const {
        mDateRange1, mDateRange2, mSelectUser,

    } = formValues;


    useEffect(() => {
        getUsers();
    }, [])



    //#region Branch 
    const getUsers = async () => {
        setLoadingUsers(true);
        const usersData = await handleRequest("GET", "Users", "Report");

        if (usersData && usersData.length > 0) {
            const formatted = usersData.map(user => ({
            value: user.id_user,
            label: `${user.username} - ${user.name} ${user.paternal_surname || ''} ${user.maternal_surname || ''}`.trim(),
            }));
            setUsers(formatted);
        } else {
            setUsers([]);
        }

        setLoadingUsers(false);
    };




    //#region Filters
    
    const getReportLogs = (e, search = true) => {
        if (e) e.preventDefault();

        if (search) {
            if (mDateRange1 && mDateRange2) {
                const start = moment(mDateRange1);
                const end = moment(mDateRange2);
                const diffDays = end.diff(start, 'days');

                if (diffDays > 31) {
                    createSweet("warning", "warning", "Atención", "No puede seleccionar un rango mayor a un mes");
                    return;
                }
            }

            let query = "";
            let from_date  = mDateRange1 ? moment(mDateRange1).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let to_date  = mDateRange2 ? moment(mDateRange2).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            let _idUser = mSelectUser ? mSelectUser.value : '';

            if (from_date  !== "") query += `${from_date }`;
            if (to_date  !== "") query += `/${to_date }`;
            if (_idUser !== "") query += `?id_user=${_idUser}`;

            setLoading(true);
            getReportLogExam(true, query, _idUser);
        }
    };

    const getReportLogExam = async (_search = false, _filter = "") => {
        setLoading(true);  
        let _listTmp = {};

        if (_search === false) {
            _listTmp = await handleRequest("GET", `WorkOrder/WorkOrderLogsUsers/`, 'Report');
        } else {
            _listTmp = await handleRequest("GET", `WorkOrder/WorkOrderLogsUsers/${_filter}`, 'Report');
        }

        if (_listTmp && Array.isArray(_listTmp)) {
            setReportLogs(_listTmp);
        } else {
            setReportLogs([]);
        }

        setLoading(false);  
    };

    
    const handleClean = () => {
        const today = moment().format("YYYY-MM-DD");

        handleUpdateValues({
            mDateRange1: "",
            mDateRange2: "",
            mSelectUser: null
        });

        const query = `${today}/${today}`;

        setLoading(true);
        getReportLogExam(true, query);
    };

    //#endregion

   

    //#region GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    // #endregion

    //#region Search
    useEffect(() => {
        setFilteredLogs(reportLogs);
    }, [reportLogs]);


    const handleSearch = (e) => {
        const busqueda = e.target.value.toUpperCase();

        const newFiltered = reportLogs.filter((element) => {
            const user = element.user?.toUpperCase() || "";
            const name = element.full_name?.toUpperCase() || "";
            const action = element.action?.toUpperCase() || "";

            return (
                user.includes(busqueda) ||
                name.includes(busqueda) ||
                action.includes(busqueda)
            );
        });

        setFilteredLogs(newFiltered);
    };


    //#endregion
    // #region Excel 

    const exportExcel = () => {
        if (!reportLogs || reportLogs.length === 0) {
            createSweet("error", "error", "", "No hay datos para exportar");
            return;
        }

        const aoa = [
            ['Usuario', 'Nombre completo', 'Fecha', 'Examen', 'Accción']
        ];

        reportLogs.forEach((row) => {
            const { created_at, action, user, full_name } = row;
            const [exam, description] = action ? action.split(" - ") : ["", ""];

            aoa.push([
                user || '',
                full_name || '',
                created_at || '',
                exam || '',
                description || ''
            ]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(aoa);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Logs_Examenes');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const fileName = 'Logs_Examenes.xlsx';
        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };


        //#endregion



    return {

        //Filter
        mDateRange1, mDateRange2, mSelectUser, users, handleInputChange, handleSelectValues, reportLogs, loading, getReportLogs,

        exportExcel, handleSearch, filteredLogs, handleClean, loadingUsers
    


    }
}
   
